// Création de l'objet à envoyer au back
import { getArrayFilesToSend } from '../../../../../../utils/fileFunction';

const formaterCreationAdressePrincipal = async (dataForm, uuidBrouillon, ban) => {
    return {
        uuidBrouillon,
        numeroDeVoie: dataForm.numeroDeVoie ?? null,
        extension: dataForm.extension ?? null,
        typeEtNomDeVoie: dataForm.typeEtNomDeVoie ?? null,
        lieuDit: dataForm.lieuDit ?? null,
        codePostal: dataForm.codePostal,
        ville: dataForm.ville,
        email: dataForm.email,
        numeroSia: dataForm.numeroSia ?? null,
        telephonePrincipal: dataForm.telephonePrincipal,
        telephoneSecondaire: dataForm.telephoneSecondaire ?? null,
        hasVerificationBan: ban,
        typeJustificatifDomicile: dataForm.typeJustificatif,
        justificatifsDomicile: dataForm.justificatifsDomicile
            ? await getArrayFilesToSend(dataForm.justificatifsDomicile)
            : null,
        certificatMedical:
            dataForm.certificatMedical && dataForm.certificatMedical[0]
                ? await dataForm.certificatMedical[0].getFileToSend()
                : null,
        immatriculationVehicule: dataForm.immatriculationVehicule ?? null,
    };
};

export default formaterCreationAdressePrincipal;
